import {useFormik} from 'formik'
import {validationDemandeDemontage} from '../../../../components/requests'
import {ModeleDemandeDemontage} from '../../../../components/Models'
import React, {useState} from 'react'
import {TextInput} from '../../../../components/inputs/TextInput'
import {Button} from 'react-bootstrap'
import {useAuth} from '../../../modules/auth'
import * as Yup from 'yup'
import {toast} from 'react-toastify'

const DemandeDemontageValidationForm = (props) => {
  const {showModalProp, demandeDemontageId, setData, data} = props
  const {currentUser} = useAuth()

  const [loading, setLoading] = useState(false)
  const [actionEnCours, setActionEnCours] = useState<'valider' | 'refuser' | null>(null)

  const initialValues: ModeleDemandeDemontage = {
    id: demandeDemontageId,
    valideParId: currentUser?.id,
    commentaireValidation: '',
    isValid: true,
  }

  const validationSchema = Yup.object().shape({
    commentaireValidation: Yup.string().when(['isValid'], {
      is: (isValid: boolean) => isValid === false,
      then: () => Yup.string().trim().required('Le commentaire est requis.'),
      otherwise: () => Yup.string().notRequired(),
    }),
    isValid: Yup.boolean().required(),
  })

  const formik = useFormik<ModeleDemandeDemontage>({
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      setLoading(true)
      validationDemandeDemontage(values)
        .then((response) => {
          setLoading(false)
          setActionEnCours(null)
          if (response?.status === 200 && response?.data !== undefined) {
            showModalProp(false)
            const statutLabel = actionEnCours === 'valider' ? 'acceptée' : 'refusée'
            toast.success(`Demande de démontage ${statutLabel}`, {autoClose: 7000})

            // Mise à jour temporaire des données du tableau
            let tmpId: string
            let tmpCode: number
            let tmpLibele: string

            if (actionEnCours == 'valider') {
              tmpId = 'VALIDE'
              tmpCode = 3
              tmpLibele = 'Validée'
            } else if (actionEnCours == 'refuser') {
              tmpId = 'REFUS'
              tmpCode = 4
              tmpLibele = 'Refusée'
            }
            const updatedData = data.map((item) =>
              item?.id === demandeDemontageId ? {...item, statut: {...item.statut,
                  code: tmpId,
                  id: tmpCode,
                  libelle: tmpLibele
              }} : item
            )
            setData(updatedData)
          }
        })
        .catch(() => {
          setLoading(false)
          setActionEnCours(null)
        })
    },
  })

  const handleSubmit = (isAccepting: boolean) => {
    setActionEnCours(isAccepting ? 'valider' : 'refuser')
    formik.setFieldValue('isValid', isAccepting).then(() => {
      formik.submitForm()
    })
  }

  return (
    <div>
      <form onSubmit={(e) => e.preventDefault()}>
        <div className='modal-body pt-3'>
          <div className='row'>
            <div className='col-sm-12'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>
                Commentaire{' '}
                {formik.values.isValid === false && <span className='text-danger'>*</span>}
              </label>
              <TextInput
                fieldName='commentaireValidation'
                inputType='text'
                inputClassName='form-control form-control-lg mb-3 mb-lg-0'
                formik={formik}
              />
            </div>
          </div>
        </div>

        <div className='modal-footer d-flex gap-4 justify-content-end'>
          <Button
            className='btn btn-primary'
            disabled={loading}
            onClick={() => handleSubmit(true)} // Accepter
          >
            {loading && actionEnCours === 'valider' ? (
              <span className='indicator-progress' style={{display: 'block'}}>
                Validation en cours...
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            ) : (
              'Valider'
            )}
          </Button>

          <Button
            className='btn btn-danger'
            disabled={loading}
            onClick={() => handleSubmit(false)} // Refuser
          >
            {loading && actionEnCours === 'refuser' ? (
              <span className='indicator-progress' style={{display: 'block'}}>
                Refus en cours...
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            ) : (
              'Refuser'
            )}
          </Button>

          <Button variant='secondary' onClick={() => showModalProp(false)} disabled={loading}>
            Annuler
          </Button>
        </div>
      </form>
    </div>
  )
}

export {DemandeDemontageValidationForm}
